import { Navigate } from "react-router";
import type { ScreenContext } from "./application-route-types";
import { entryPath, moduleFor, narrowedFor } from "./destinations";
import { lazyScreen } from "./lazy-screen";
import { NotFound } from "./not-found";
import { recordOf } from "./records";

const PROCESS_RECORD = recordOf("process");
const RecordScreen = lazyScreen(() => import("./record-screen"), "RecordScreen");

export function ProcessDetail({ state }: Pick<ScreenContext, "state">) {
  return (
    <RecordScreen
      record={PROCESS_RECORD}
      roles={state.riksu.roles ?? []}
      mine={state.riksu.person?.person_id ?? null}
    />
  );
}

export function DestinationEntrance({
  at,
  state,
}: {
  readonly at: string;
  readonly state: ScreenContext["state"];
}) {
  const destination = moduleFor(at);
  if (!destination) return <NotFound />;
  return <Navigate to={entryPath(narrowedFor(destination, state.riksu))} replace />;
}
